import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Card, CardBody, Button } from 'reactstrap';
import { FiUser, FiTrendingUp } from 'react-icons/fi';
import { TrackPostHogEvent } from '../../../shared/utils/posthog';

const RoleSelection = ({ onRoleSelect, selectedRole, user }) => {
  const [isUpdating, setIsUpdating] = useState(false);

  const handleRoleClick = (role) => {
    // Track role card interaction
    TrackPostHogEvent('onboarding_role_card_clicked', {
      clicked_role: role,
      previous_selection: selectedRole,
      is_changing_selection: selectedRole && selectedRole !== role,
      timestamp: new Date().toISOString()
    });
    
    onRoleSelect(role);
  };

  const handleRoleHover = (role) => {
    // Track role consideration (hover events)
    TrackPostHogEvent('onboarding_role_card_hovered', {
      hovered_role: role,
      current_selection: selectedRole,
      timestamp: new Date().toISOString()
    });
  };

  return (
    <div className="role-selection">
      <div className="role-selection-header">
        <h2>What brings you to OpenGraph.io?</h2>
        <p className="role-selection-subtext">
          Choose the path that best fits how you plan to use the platform.
        </p>
      </div>

      <div className="role-cards">
        <CardBody 
          className={`role-card developer-card ${selectedRole === 'developer' ? 'selected' : ''}`} 
          onClick={() => handleRoleClick('developer')}
          onMouseEnter={() => handleRoleHover('developer')}
        >
          <div className="role-card-icon">
            <FiUser size={24} />
            <span className="role-emoji">🧑‍💻</span>
          </div>
          <h4 className="role-card-title">I'm a Developer</h4>
          <p className="role-card-description">
            I need to fetch Open Graph or metadata from URLs using the API. I want to test how it works and integrate it into my app or workflow.
          </p>
        </CardBody>

        <CardBody 
          className={`role-card marketer-card ${selectedRole === 'marketer' ? 'selected' : ''}`} 
          onClick={() => handleRoleClick('marketer')}
          onMouseEnter={() => handleRoleHover('marketer')}
        >
          <div className="role-card-icon">
            <FiTrendingUp size={24} />
            <span className="role-emoji">📈</span>
          </div>
          <h4 className="role-card-title">I'm a Marketer</h4>
          <p className="role-card-description">
            I'm looking to generate link previews or enrich content with better visuals. I want an easy way to turn links into engaging previews.
          </p>
        </CardBody>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.users.user,
});

export default connect(mapStateToProps)(RoleSelection); 